import { IFoDotDangKyPhamVi } from "../../../models/response/thuc-don/IFoDotDangKyPhamVi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const objDotDangKyPhamViDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: [] as IFoDotDangKyPhamVi[],
    LOAD_ERROR: "",
    LOAD_BY_DOT_DANG_KY_START: 0,
    LOAD_BY_DOT_DANG_KY_SUCCESS: [] as IFoDotDangKyPhamVi[],
    LOAD_BY_DOT_DANG_KY_ERROR: "",
    LOAD_BY_TRUONG_START: 0,
    LOAD_BY_TRUONG_SUCCESS: [] as IFoDotDangKyPhamVi[],
    LOAD_BY_TRUONG_ERROR: "",
};

export const eFoDotDangKyPhamViActionTypeIds = generateActionTypeIds(objDotDangKyPhamViDefine, "DOT_DANG_KY_PHAM_VI");

export type IFoDotDangKyPhamViActionTypes = IGenericActionType<typeof objDotDangKyPhamViDefine, "DOT_DANG_KY_PHAM_VI">;
